import {useCallback, useEffect, useRef, useState} from 'react';
import {listFinanceiroFaturas} from './FinanceiroService';
import {extrairPaginaDeFaturas, getBackendMessage} from './financeiroUtils';

export const FATURAS_POR_PAGINA = 20;

const paginacaoVazia = () => ({page: 1, total: 0, totalPages: 1, hasNext: false, hasPrevious: false});

/**
 * Faturas das empresas em que a pessoa tem vínculo ativo, em qualquer situação da assinatura
 * (o escopo é da API). O filtro de situação vai para a API, e a página volta para a primeira.
 */
export function useFinanceiro() {
    const [faturas, setFaturas] = useState([]);
    const [pagination, setPagination] = useState(paginacaoVazia);
    const [page, setPage] = useState(1);
    const [status, setStatusState] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    // Só a resposta do último pedido vale: trocar o filtro rápido não deixa a lista velha por cima.
    const ultimoPedido = useRef(0);

    const loadFaturas = useCallback(async () => {
        const pedido = ultimoPedido.current + 1;
        ultimoPedido.current = pedido;
        setLoading(true);
        setError('');

        try {
            const response = await listFinanceiroFaturas({page, page_size: FATURAS_POR_PAGINA, status});
            if (pedido !== ultimoPedido.current) return;
            const result = extrairPaginaDeFaturas(response);
            setFaturas(result.items);
            setPagination(result.pagination);
        } catch (loadError) {
            if (pedido !== ultimoPedido.current) return;
            setFaturas([]);
            setPagination(paginacaoVazia());
            setError(getBackendMessage(loadError, 'Não foi possível carregar as faturas.'));
        } finally {
            if (pedido === ultimoPedido.current) setLoading(false);
        }
    }, [page, status]);

    useEffect(() => {
        loadFaturas();
    }, [loadFaturas]);

    const setStatus = useCallback((value) => {
        setStatusState(value);
        setPage(1);
    }, []);

    return {
        faturas,
        pagination,
        page,
        setPage,
        status,
        setStatus,
        loading,
        error,
        reload: loadFaturas,
    };
}
